//REACT
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//
import { useGetProductsPaginatedQuery } from "../../../productAPI";

//YUP
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

//MUI
import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";

import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { MenuItem, Typography } from "@mui/material";

//COMPONENTS
import { CustomScrollbar } from "../../customScrollbar/CustomScrollbar";

//LIST
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

//DATEFIELD
import { DatePicker } from "@mui/lab";

//TRANFER LIST
import ProductTransferList from "../../productTransferList/productTransferList";

const schema = yup.object().shape({
  code: yup.string().required("Code is required"),
  description: yup.string(),
  points: yup.number().required("Points are required").integer(),
  startDate: yup
    .date()
    .required("The Start date is required")
    .max(yup.ref("endDate"), "Start date cannot be after End date"),
  endDate: yup
    .date()
    .required("The End date is required")
    .min(yup.ref("startDate"), "End date cannot be before Start date"),
  completed: yup.boolean(),
  missionPartecipationThreshold: yup.number().integer().required(),
  enabled: yup.boolean(),
  tag: yup.string(),
  tagColor: yup.string(),
  titleColor: yup.string(),
  descriptionColor: yup.string(),
  type: yup.string(),
  // image: yup.object().shape({
  //   id: yup.number().integer(),
  //   isFolder: yup.bool(),
  //   tag: yup.string(),
  //   url: yup.string().url("Image link must be a valid URL"),
  //}),
});

const Form = ({ mode = "create", handleSave, currentProduct }) => {
  const isEdit = mode === "edit";
  const { id, dataCreation, ...mission } = currentProduct;

  const defaultValues = {
    ...{
      code: "",
      description: "",
      points: 0,
      startDate: null,
      endDate: null,
      completed: false,
      missionPartecipationThreshold: "",
      enabled: true,
      tag: "",
      tagColor: "",
      titleColor: "",
      descriptionColor: "",
      type: "",
      image: {},
      products: [],
    },
    ...mission,
  };

  const form = useForm({
    defaultValues,
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { register, handleSubmit, formState, reset, setValue } = form;
  const { errors, isValid, isDirty } = formState;

  useEffect(() => {
    reset(defaultValues);
  }, [currentProduct]);

  //NESTED LIST
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(!open);

  //TYPE && EXTRA POINT TYPE LISTS
  const { data } = useGetProductsPaginatedQuery({
    activeType: "producttypeenums",
  });
  const types = data?.mission?.type || [];
  const extraPointTypes = data?.mission?.extraPointType || [];

  const [selectedType, setSelectedType] = useState(currentProduct.type || "");
  const handleSelectType = (type) => {
    setSelectedType(type);
    setValue("type", type);
  };

  const [selectedExtraPointType, setSelectedExtraPointType] = useState(
    currentProduct.extraPointType || ""
  );
  const handleSelectExtraPointType = (extraPointType) => {
    setSelectedExtraPointType(extraPointType);
    setValue("extraPointType", extraPointType);
  };

  useEffect(() => {
    setSelectedType(currentProduct.type || "");
    setSelectedExtraPointType(currentProduct.extraPointType || "");
    reset(defaultValues);
  }, [currentProduct]);

  //BOOLEANS LOGIC

  const booleanOptions = [true, false];

  //Completed

  const [selectedCompleted, setSelectedCompleted] = useState(
    currentProduct.completed || ""
  );

  const handleSelectCompleted = (completed) => {
    setSelectedCompleted(completed);
    setValue("completed", completed);
  };

  useEffect(() => {
    setSelectedCompleted(currentProduct.completed || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //Enabled

  const [selectedEnabled, setSelectedEnabled] = useState(
    currentProduct.enabled || ""
  );

  const handleSelectEnabled = (enabled) => {
    setSelectedEnabled(enabled);
    setValue("enabled", enabled);
  };

  useEffect(() => {
    setSelectedEnabled(currentProduct.enabled || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //END OF BOOLEANS LOGIC

  //Associated Products
  const getAssociatedProducts = () => {
    return (
      currentProduct?.products?.map((product) => ({
        id: product?.id,
        title: product?.title,
        productCode: product?.productCode,
        dataCreation: product?.dataCreation,
        price: product?.price,
        country: product?.country,
        description: product?.description,
        imageLink: product?.imageLink,
        promoCode: product?.promoCode,
        productType: product?.productType,
        points: product?.points,
        mission: product?.mission,
        promoPrefixes: product?.promoPrefixes,
      })) || []
    );
  };

  //Selected data from Product Transfer List (Right)
  const [products, setProducts] = useState("");

  const handleProductListChange = (selectedProducts) => {
    const selectedProductIds = selectedProducts?.map((product) => ({
      id: product.id,
    }));
    const productsData =
      selectedProductIds?.length > 0 ? selectedProductIds : [];
    setProducts(productsData);
    console.log("Data To BE", { products: productsData });
  };

  const onSubmit = (data) => {
    data.products = products;
    console.log("Data To BE", data);
    handleSave(data);
  };

  return (
    <CustomScrollbar>
      <Box
        id="missionForm"
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        maxWidth="95%"
        maxHeight="35vw"
        background="gray"
      >
        <Grid2 container spacing={3}>
          <Grid2 xs={12}>
            <Typography variant="h3" color="primary">
              Mission {isEdit ? "details" : "creation"}
            </Typography>
          </Grid2>
          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Code"
              color="primary"
              fullWidth
              error={!!errors.code}
              helperText={errors.code?.message}
              {...register("code")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Description"
              id="outlined-multiline-flexible"
              multiline
              color="primary"
              fullWidth
              error={!!errors.description}
              helperText={errors.description?.message}
              {...register("description")}
            />
          </Grid2>

          <Grid2 xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Points"
              color="primary"
              fullWidth
              error={!!errors.points}
              helperText={errors.points?.message}
              {...register("points")}
            />
          </Grid2>

          <Grid2 xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Mission partecipation threshold"
              color="primary"
              fullWidth
              error={!!errors.missionPartecipationThreshold}
              helperText={errors.missionPartecipationThreshold?.message}
              {...register("missionPartecipationThreshold")}
            />
          </Grid2>

          <Grid2 xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Start date"
              type="date"
              color="primary"
              fullWidth
              error={!!errors.startDate}
              helperText={errors.startDate?.message}
              {...register("startDate")}
            />
            <DatePicker />
          </Grid2>

          <Grid2 xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="End date"
              type="date"
              color="primary"
              fullWidth
              error={!!errors.endDate}
              helperText={errors.endDate?.message}
              {...register("endDate")}
            />
            <DatePicker />
          </Grid2>

          {/* BOOLEANS */}
          <Grid2 item xs={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Completed"
              color="primary"
              fullWidth
              select
              value={selectedCompleted}
              onChange={(event) => handleSelectCompleted(event.target.value)}
              title="Completed"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Enabled"
              color="primary"
              fullWidth
              select
              value={selectedEnabled}
              onChange={(event) => handleSelectEnabled(event.target.value)}
              title="Enabled"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          {/* END OF BOOLEANS */}

          <Grid2 xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Tag"
              color="primary"
              fullWidth
              error={!!errors.tag}
              helperText={errors.tag?.message}
              {...register("tag")}
            />
          </Grid2>

          <Grid2 xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Tag Color"
              color="primary"
              fullWidth
              error={!!errors.tagColor}
              helperText={errors.tagColor?.message}
              {...register("tagColor")}
            />
          </Grid2>

          <Grid2 xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Title Color"
              color="primary"
              fullWidth
              error={!!errors.titleColor}
              helperText={errors.titleColor?.message}
              {...register("titleColor")}
            />
          </Grid2>

          <Grid2 xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Description Color"
              color="primary"
              fullWidth
              error={!!errors.descriptionColor}
              helperText={errors.descriptionColor?.message}
              {...register("descriptionColor")}
            />
          </Grid2>

          <Grid2 item xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Type"
              color="primary"
              fullWidth
              select
              value={selectedType}
              onChange={(event) => handleSelectType(event.target.value)}
            >
              {types.map((type) => (
                <MenuItem key={type} value={type}>
                  <Typography variant="subtitle2">{type}</Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>
          <Grid2 item xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Extra Point Type"
              color="primary"
              fullWidth
              select
              value={selectedExtraPointType}
              onChange={(event) =>
                handleSelectExtraPointType(event.target.value)
              }
            >
              {extraPointTypes.map((extraPointType) => (
                <MenuItem key={extraPointType} value={extraPointType}>
                  <Typography variant="subtitle2">{extraPointType}</Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 xs={12}>
            <List
              sx={{  }}
              component="nav"
              aria-labelledby="nested-list-subheader"
              {...register("image")}
            >
              <ListItemButton
                onClick={handleClick}
                sx={{
                  border: 1,
                  borderColor: "lightgrey",
                  boxShadow: 1,
                  borderRadius: "5px",
                }}
              >
                <ListItemText primary="Image" />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  sx={{
                    border: 1,
                    borderColor: "lightgrey",
                    borderRadius: "5px",
                  }}
                >
                  <ListItemButton sx={{ pl: 2 }}>
                    <Grid2 xs={12}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        color="primary"
                        fullWidth
                        label="Image ID"
                        value={form.watch("image.id")}
                        {...register("image.id")}
                        sx={{ marginTop: "10px", marginBottom: "10px" }}
                      />
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        color="primary"
                        fullWidth
                        label="Is folder?"
                        value={form.watch("image.isFolder")}
                        {...register("image.isFolder")}
                        sx={{ marginTop: "10px", marginBottom: "10px" }}
                      />

                      <TextField
                        InputLabelProps={{ shrink: true }}
                        color="primary"
                        fullWidth
                        label="Image Tag"
                        value={form.watch("image.tag")}
                        {...register("image.tag")}
                        sx={{ marginTop: "10px", marginBottom: "10px" }}
                      />
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        color="primary"
                        fullWidth
                        label="Image URL"
                        value={form.watch("image.url")}
                        {...register("image.url")}
                        sx={{ marginTop: "10px", marginBottom: "10px" }}
                      />
                    </Grid2>
                  </ListItemButton>
                </List>
              </Collapse>
            </List>
          </Grid2>

          <Grid2 xs={12}>
            <ProductTransferList
              onExportRightData={handleProductListChange}
              associatedProducts={getAssociatedProducts()}
              currentProduct={currentProduct}
            />
          </Grid2>

          <Grid2 xs={6} sx={{ display: "none" }}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Product ID"
              color="primary"
              fullWidth
              value={products}
              {...register("products.id")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <Tooltip arrow title={(false && "a") || ""}>
              <LoadingButton
                type="submit"
                loading={false}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                sx={{
                  boxShadow: "none",
                  padding: "5px 12px 4px 12px",
                }}
                color="primary"
                onClick={() => {}}
                disabled={isDirty && !isValid}
              >
                Save
              </LoadingButton>
            </Tooltip>
          </Grid2>
        </Grid2>
      </Box>
    </CustomScrollbar>
  );
};

export default Form;
